export const parseDigitsOnly = (value: any) => {
  if (value === null || value === undefined) return value;
  const s = String(value);
  const digits = s.replace(/\D+/g, "");
  return digits;
};
